import { PRICE_SOURCE } from "../indicatorTypes";

const PRICE_READERS = {
  [PRICE_SOURCE.CLOSE]: (bar) => bar.close,
  [PRICE_SOURCE.OPEN]: (bar) => bar.open,
  [PRICE_SOURCE.HIGH]: (bar) => bar.high,
  [PRICE_SOURCE.LOW]: (bar) => bar.low,
  [PRICE_SOURCE.HL2]: (bar) => (bar.high + bar.low) / 2,
  [PRICE_SOURCE.HLC3]: (bar) => (bar.high + bar.low + bar.close) / 3,
  [PRICE_SOURCE.OHLC4]: (bar) => (bar.open + bar.high + bar.low + bar.close) / 4,
};

/**
 * Reader of one price of the bars by index, the input of the moving
 * averages and other window calculations (math/movingAverages.js).
 *
 * @param {object[]} bars - { open, high, low, close }
 * @param {string} source - PRICE_SOURCE value; close when unknown
 * @returns {(index: number) => number}
 */
export const priceReader = (bars, source) => {
  const readPrice = PRICE_READERS[source] || PRICE_READERS[PRICE_SOURCE.CLOSE];

  return (index) => readPrice(bars[index]);
};

/**
 * Reader of calculated values by index (an indicator built on another one,
 * e.g. the MACD signal line); NaN where there is no value.
 *
 * @param {number[]} values
 * @returns {(index: number) => number}
 */
export const valuesReader = (values) => (index) => {
  const value = values[index];

  return value === undefined ? NaN : value;
};
